$(document).on("click",".video_box  img.video_img",function(){
  $(this).hide();
  $(this).closest(".video_box").find(".play_btn").hide();
    $(this).closest(".video_box").find(".video_code").show();
});
$(document).on("click",".close_popup",function(e){
 e.preventDefault();
  $(".popup_custom").hide();
});

$(".product.product--medium.grid fieldset.js.product-form__input input").removeAttr("checked");
$('.banner_slider').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: true,
  nextArrow: '.next_btn_home',
  prevArrow: '.prev_btn_home',
   appendDots: $('.home_slider_dots'),
 responsive: [
  
    {
      breakpoint: 990,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    } 
  ]
});
$('.test_slider').slick({
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  dots: true,
  nextArrow: '.next_btn_home',
  prevArrow: '.prev_btn_home',
   appendDots: $('.home_slider_dots'),
 responsive: [
  
    {
      breakpoint: 990,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    } 
  ]
});
$('.video_slider').slick({
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  dots: true,
  nextArrow: '.next_btn',
  prevArrow: '.prev_btn',
    appendDots: $('.video_slider_dots'),
 responsive: [
  
    {
      breakpoint: 990,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    } 
  ]
});
$('.collection-list.collection_slider_l').slick({
  infinite: true,
  slidesToShow:5,
  slidesToScroll: 1,
  dots: false,
  nextArrow: '.next_btn_col',
  prevArrow: '.prev_btn_col',
 responsive: [
  
    {
      breakpoint: 990,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    } 
  ]
});

$('.logo_slider').slick({
  infinite: true,
  slidesToShow: 6,
  slidesToScroll: 1, 
  arrows:false,
 responsive: [
  
    {
      breakpoint: 990,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    } 
  ]
});